module.exports = __webpack_public_path__ + "7a00fde4cb4d4a5e608f52b31a1f24b9.png";